import { useMutation, gql } from '@apollo/client';
import {
  CadastrarCursoMutation,
  CadastrarCursoMutationVariables,
} from './__generated__/CadastrarCursoMutation';

const CADASTRAR_CURSO_MUTATION = gql`
  mutation CadastrarCursoMutation(
    $id_unidade: Int!
    $dsc_nome_curso: String!
    $dsc_sigla_curso: String!
    $dsc_nome_apoio: String
    $dsc_email_apoio: String
    $dsc_telefone_apoio: String
    $ativo: Boolean
  ) {
    cadastrarCurso(
      input: {
        id_unidade: $id_unidade
        dsc_nome_curso: $dsc_nome_curso
        dsc_sigla_curso: $dsc_sigla_curso
        dsc_nome_apoio: $dsc_nome_apoio
        dsc_email_apoio: $dsc_email_apoio
        dsc_telefone_apoio: $dsc_telefone_apoio
        ativo: $ativo
      }
    ) {
      id_curso
      id_unidade
      dsc_nome_curso
      dsc_sigla_curso
      dsc_nome_apoio
      dsc_email_apoio
      dsc_telefone_apoio
      ativo

      ofertas {
        id_oferta
        num_oferta
        num_ano
        num_semestre
        ativa
        dsc_email_assistente
        dat_inicio
        dat_fim

        turmas {
          id_turma
          id_horario
          num_turma
          dias_semana
          ativa
        }
      }
    }
  }
`;

const useCadastrarCursoMutation = () => {
  return useMutation<CadastrarCursoMutation, CadastrarCursoMutationVariables>(
    CADASTRAR_CURSO_MUTATION
  );
};

export { useCadastrarCursoMutation };
